// src/utils/sendEmail.js
// Client-side helper. Calls our Vercel serverless function which sends via Resend.

export async function sendEmail({ type, to, data = {} }) {
  try {
    const res = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, to, data }),
    });

    const text = await res.text().catch(() => '');
    let payload = null;
    try { payload = JSON.parse(text); } catch (_) { /* not JSON */ }

    if (!res.ok) {
      const error = (payload && payload.error) || text || ('HTTP ' + res.status);
      console.error('[sendEmail] HTTP', res.status, error, payload);
      if (payload && payload.log && !payload.log.ok) {
        console.error('[sendEmail] CRM logging failed:', payload.log);
      }
      return { ok: false, error, log: payload && payload.log };
    }

    // Surface logging diagnostics on success too — silent CRM tracking
    // regressions otherwise hide in Vercel function logs.
    if (payload && payload.log && !payload.log.ok) {
      console.error('[sendEmail] email sent but CRM logging FAILED:', payload.log);
    } else if (payload && payload.log && payload.log.ok) {
      console.log('[sendEmail] email sent and logged (auth:', payload.log.authMode + ')');
    }

    return { ok: true, log: payload && payload.log };
  } catch (err) {
    console.error('Email request failed:', err);
    return { ok: false, error: err.message };
  }
}

export async function sendWelcomeEmail({ firstName, email }) {
  return sendEmail({ type: 'welcome', to: email, data: { name: firstName } });
}

export async function sendPriceDropEmail({ firstName, email, listingTitle, listingCity, oldPrice, newPrice, listingId }) {
  return sendEmail({
    type: 'price-drop',
    to: email,
    data: { firstName, listingTitle, listingCity, oldPrice, newPrice, listingId },
  });
}

export async function sendPasswordChangedEmail({ firstName, email, changedAt }) {
  return sendEmail({
    type: 'password-changed',
    to: email,
    data: { firstName, changedAt },
  });
}
